import { render } from "./BaseLoadingText.vue?vue&type=template&id=684cef12"
const script = {}
script.render = render

export default script